import React, { useEffect } from "react"
import { Keyboard } from "~/ui/primitives"
import Emoji from "./emoji"

interface Props {
  onChangeText: (t: string) => void
}

const EmojiMode: React.FC<Props> = ({ onChangeText }) => {
  useEffect(() => {
    Keyboard.dismiss()
  }, [])

  return <Emoji onSelect={onChangeText} />
}

export default EmojiMode
